import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SoundProvider } from './contexts/SoundContext';
import UnifiedDashboard from './components/UnifiedDashboard';
import DemoSelection from './components/DemoSelection';
import SumGrid from './components/SumGrid';
import MultiplicationGrid from './components/MultiplicationGrid';
import CombinedGrid from './components/CombinedGrid';
import MentalMathSpeedRound from './components/MentalMathSpeedRound';
import PuzzleGamesSelection from './components/PuzzleGamesSelection';
import Login from './components/Login';
import SignupWithSubscription from './components/SignupWithSubscription';
import SignupWithElements from './components/SignupWithElements';
import SignupNew from './components/SignupNew';
import SignupReturn from './components/SignupReturn';
import SignupSuccess from './components/SignupSuccess';
import SubscriptionPlans from './components/SubscriptionPlans';
import Profile from './components/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import ProfileSetupGuard from './components/ProfileSetupGuard';
import NotFound from './components/NotFound';
import ResetPassword from './components/ResetPassword';
import UpdatePassword from './components/UpdatePassword';
import UpgradePage from './components/UpgradePage';
import AdminInvite from './components/AdminInvite';
import AboutUs from './components/AboutUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import LegalAgreement from './components/LegalAgreement';
import RouteHandler from './components/RouteHandler';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <RouteHandler>
            <ProfileSetupGuard>
              <Routes>
                {/* Non-game routes (no sound needed) */}
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/update-password" element={<UpdatePassword />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signin" element={<Login />} />
                <Route path="/signup" element={<SignupNew />} />
                <Route path="/signup/elements" element={<SignupWithElements />} />
                <Route path="/signup/subscription" element={<SignupWithSubscription />} />
                <Route path="/signup/account" element={<SignupReturn />} />
                <Route path="/signup/success" element={<SignupSuccess />} />
                <Route path="/signup-success" element={<SignupSuccess />} />
                <Route path="/plans" element={<SubscriptionPlans onSelectPlan={() => {}} />} />
                <Route path="/upgrade" element={<UpgradePage />} />
                <Route path="/admin/invite" element={<ProtectedRoute><AdminInvite /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/legal-agreement" element={<LegalAgreement />} />
                
                {/* Dashboard and navigation pages */}
                <Route path="/" element={<UnifiedDashboard />} />
                <Route path="/demo" element={<SoundProvider><DemoSelection /></SoundProvider>} />
                <Route path="/puzzle-games" element={<SoundProvider><ProtectedRoute><PuzzleGamesSelection /></ProtectedRoute></SoundProvider>} />
                
                {/* Game routes (need sound) */}
                <Route path="/sum-grid" element={<SoundProvider><SumGrid /></SoundProvider>} />
                <Route path="/multiplication-grid" element={<SoundProvider><MultiplicationGrid /></SoundProvider>} />
                <Route path="/combined-grid" element={<SoundProvider><CombinedGrid /></SoundProvider>} />
                <Route path="/mental-math-speed" element={<SoundProvider><MentalMathSpeedRound /></SoundProvider>} />
                
                {/* 404 Catch-all route - must be last */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ProfileSetupGuard>
          </RouteHandler>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
